import {
    CREATE_SPOT_LIST_REQUEST,
    createSpotListSuccess,
    createSpotListFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const createSpotListEpic: TEpic = (action$, store$, { SpotListRepository }) => {
    return action$.pipe(
        ofType(CREATE_SPOT_LIST_REQUEST),
        mergeMap(action => from(SpotListRepository.create( action.payload.spotListData ))
            .pipe(
                mergeMap((spotList) => {
                    return from([
                        showSuccessNotification(`SpotList wurde erfolgreich erstellt`),
                        createSpotListSuccess( spotList ),
                    ]);
                }),
                catchError( error => {
                    return from([
                        createSpotListFailure(error),
                    ])
                })
            )
        ),
    );
}
